import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

//import BottomNavigation, { BottomNavigationAction } from 'material-ui/BottomNavigation';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

import RestoreIcon from '@material-ui/icons/Restore';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ProfileIcon from '@material-ui/icons/Person';

import HomeIcon from '@material-ui/icons/Home';

import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Ionicon from 'react-ionicons';

import { setActiveTab } from '../../modules/tabs';

const styles = {
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0
  }
};

const BOTTOM_TABS = ['/', '/add', '/profile', '/more'];

class BottomTabs extends Component {
  componentDidMount() {
    this._onLoad();
  }

  componentWillUnmount() {
    this._unlisten();
  }

  handleChange = (event, value) => {
    this.props.setActiveTab(value);
  };

  _handleChange = tab => {
    this.props.setActiveTab(tab);
  };

  _onLoad = () => {
    let url = window.location.pathname;

    // Home
    if (url === '/') {
      return this._handleChange(0);
    }

    // Add Donation
    if (url === '/add') {
      return this._handleChange(1);
    }

    // Profile
    if (url === '/profile') {
      return this._handleChange(2);
    }

    // More
    if (url === '/more') {
      return this._handleChange(3);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { activeTab, location } = this.props;

    // if tab changed
    if (prevProps.activeTab !== activeTab) {
      // Home
      if (activeTab === 0) {
        this.props.changePage('/');
      }

      // Add Donation
      if (activeTab === 1) {
        this.props.changePage('/add');
      }

      // Profile
      if (activeTab === 2) {
        this.props.changePage('/profile');
      }

      // More
      if (activeTab === 3) {
        this.props.changePage('/more');
      }
    }

    if (BOTTOM_TABS.includes(location.pathname)) {
      this._onLoad();
    }

    if (!BOTTOM_TABS.includes(location.pathname)) {
      this._handleChange(null);
    }
  }

  render() {
    const { classes, activeTab, loggedIn } = this.props;

    if (!loggedIn) {
      return <div />;
    }

    return (
      <BottomNavigation
        value={activeTab}
        onChange={this.handleChange}
        showLabels
        className={classes.root}>
        <BottomNavigationAction label="Home" icon={<HomeIcon />} />

        <BottomNavigationAction
          label="Donation"
          icon={<Ionicon icon="md-add" />}
        />

        <BottomNavigationAction
          label="Profile"
          icon={<Ionicon icon="md-person" />}
        />

        <BottomNavigationAction
          label="More"
          icon={<Ionicon icon="ios-menu" />}
        />
      </BottomNavigation>
    );
  }
}

BottomTabs.propTypes = {
  classes: PropTypes.object.isRequired
};

BottomTabs = withStyles(styles)(BottomTabs);

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn,
  activeTab: state.tabs.activeTab,
  location: state.router.location
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setActiveTab: tab => dispatch(setActiveTab(tab)),
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BottomTabs);



// WEBPACK FOOTER //
// ./src/components/BottomTabs/index.js